import { render, staticRenderFns } from "./HintForEdit.vue?vue&type=template&id=2b30027e&scoped=true&lang=pug&"
import script from "./HintForEdit.vue?vue&type=script&lang=js&"
export * from "./HintForEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30027e",
  null
  
)

export default component.exports